import { useInfiniteQuery } from "@tanstack/react-query"
import { apiFetch } from "../framework/api"
import { buildPaginationParams } from "../utils/pagination"
import { useAuthToken } from "./useAuthToken"

export type PlaceRow = {
  id: string
  name: string
  type: string
  latitude: number
  longitude: number
  osmRef: string
  updatedAt: string
  mergedProps?: Record<string, unknown> | null
}

type UsePlacesParams = {
  filter?: string
  sort: string
  dir: "asc" | "desc"
  limit?: number
}

type PlacesResponse = {
  places: PlaceRow[]
  nextCursor?: string
}

export function usePlaces({ filter, sort, dir, limit = 100 }: UsePlacesParams) {
  const token = useAuthToken()

  return useInfiniteQuery({
    queryKey: ["places", { filter, sort, dir, limit }],
    queryFn: async ({ pageParam }) => {
      const params = buildPaginationParams({ cursor: pageParam, filter, sort, dir, limit })
      const data = await apiFetch<PlacesResponse | PlaceRow[]>(`/admin/places?${params}`, {
        token,
        method: "GET",
      })
      if (Array.isArray(data)) {
        return { places: data, nextCursor: undefined }
      }
      return data
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    initialPageParam: undefined as string | undefined,
  })
}
